import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { deleteModel } from 'scenes/Labels/sources/labels';

import { remove } from '../queryKeyFactory';

export const useDeleteLabel = () => {
  const confirm = useScreenModalV2(ConfirmDialog);

  const deleteMutation = useMutation(remove(), deleteModel, {
    successMessage: () => `Label Deleted`,
    refresh: true,
  });

  const handleDelete = ({ id, name }) =>
    confirm({
      title: `Delete Label?`,
      bodyText: `${name}`,
      confirmActionLabel: 'Delete',
    }).then(() => deleteMutation.mutateAsync({ id }));

  return [handleDelete, deleteMutation];
};
